import { getDeliveryClient } from ".";

const getPrivacyPolicy = async () => {
  const result = {
    error: undefined,
    response: {},
  };
  try {
    const response = await getDeliveryClient()
      .items()
      .type("feelperformer_privacy_policy")
      .toPromise();

    const title = response?.firstItem?.system?.name;
    const content = response?.firstItem?.content?.value;

    result.response = {
      title,
      content,
    };
  } catch (error) {
    console.log("error getPrivacyPolicy", error);
    result.error = error;
  }
  return result;
};

const getTermsAndConditions = async () => {
  const result = {
    error: undefined,
    response: {},
  };
  try {
    const response = await getDeliveryClient()
      .items()
      .type("feelperformer_terms_and_conditions")
      .toPromise();

    const title = response?.firstItem?.system?.name;
    const content = response?.firstItem?.content?.value;

    result.response = {
      title,
      content,
    };
  } catch (error) {
    console.log("error getTermsAndConditions", error);
    result.error = error;
  }
  return result;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { getPrivacyPolicy, getTermsAndConditions };
